import { createAvatar } from "@dicebear/core";
import { create, meta, schema } from "@dicebear/thumbs";

/**
 * Avatar resolver isomorfik — jalan di RSC maupun client island (TANPA
 * directive "use client"; dicebear aman di kedua runtime). Ini SATU-SATUNYA
 * modul yang menyentuh @dicebear.
 *
 * Cache data-URI per-seed dalam memori proses (server: antar-request satu
 * proses; client: antar-render). Deterministik per seed → SSR dan hydration
 * selalu sepakat, tanpa flicker.
 */
const cache = new Map<string, string>();

/** DiceBear thumbs SVG (data URI) dari seed — deterministik. */
function generateAvatar(seed: string): string {
  return createAvatar({ create, meta, schema }, { seed }).toDataUri();
}

/**
 * Resolusi avatar: URL terunggah dipakai apa adanya; kalau kosong, data-URI
 * DiceBear dibangun dari `seed` (di-cache per-seed). Dipakai di RSC
 * (layout/page — hasil dikirim ke client sebagai prop string) maupun di
 * island untuk data runtime-dinamis: baris leaderboard/hasil ujian hasil
 * fetch client, preview avatar edit-profil saat nama diketik.
 */
export function getAvatar(url: string | null | undefined, seed: string): string {
  if (url) return url;

  const key = seed || "User";
  const cached = cache.get(key);
  if (cached) return cached;

  const dataUri = generateAvatar(key);
  cache.set(key, dataUri);
  return dataUri;
}
